module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "绘本兑换"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "bookExchangeForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.param,
      "rules": _vm.bookExchangeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请输入兑换码",
      "prop": "activity"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.param.code),
      callback: function($$v) {
        _vm.$set(_vm.param, "code", _vm._n($$v))
      },
      expression: "param.code"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.exchange
    }
  }, [_vm._v("兑换")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e61b2a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/BookExchangeModal.vue
// module id = 1731
// module chunks = 8